// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1eGvH","rootNoMargin":"styles_rootNoMargin__2nwJB"};